module.exports = __webpack_public_path__ + "static/media/pause.e7cb5fd3.svg";